// Hero Parallax Effect for Tinker Theme
(function() {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }

  function initParallax() {
    const heroSections = document.querySelectorAll('.hero-wrapper .hero');
    
    if (heroSections.length === 0) return;

    heroSections.forEach(hero => {
      const mediaWrapper = hero.querySelector('.hero__media-wrapper');
      const contentWrapper = hero.querySelector('.hero__content-wrapper');
      const images = hero.querySelectorAll('.hero__image');
      const videos = hero.querySelectorAll('.hero__video-wrapper');
      
      if (!mediaWrapper) return;

      // Add parallax on scroll
      let ticking = false;
      
      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            applyParallax(hero, mediaWrapper, contentWrapper, images, videos);
            ticking = false;
          });
          ticking = true;
        }
      });

      // Initial call
      applyParallax(hero, mediaWrapper, contentWrapper, images, videos);
    });
  }

  function applyParallax(hero, mediaWrapper, contentWrapper, images, videos) {
    const heroRect = hero.getBoundingClientRect();
    const heroTop = heroRect.top;
    const heroHeight = heroRect.height;
    
    // Only apply parallax when hero is in viewport
    if (heroTop > window.innerHeight || heroTop + heroHeight < 0) return;
    
    // Calculate scroll position relative to hero
    const scrolled = -heroTop;
    const scrollPercent = scrolled / heroHeight;
    
    // Apply different speeds for different elements
    if (mediaWrapper) {
      const bgSpeed = scrolled * 0.5;
      mediaWrapper.style.transform = `translate3d(0, ${bgSpeed}px, 0)`;
    }

    // Parallax for images
    images.forEach((img, index) => {
      const speed = 0.3 + (index * 0.1);
      const offset = scrolled * speed;
      img.style.transform = `translate3d(0, ${offset}px, 0)`;
    });

    // Parallax for videos
    videos.forEach((video, index) => {
      const speed = 0.4 + (index * 0.1);
      const offset = scrolled * speed;
      video.style.transform = `translate3d(0, ${offset}px, 0)`;
    });

    // Content parallax and fade
    if (contentWrapper) {
      const contentSpeed = scrolled * 0.2;
      const opacity = Math.max(0, 1 - (scrollPercent * 1.5));
      contentWrapper.style.transform = `translate3d(0, ${contentSpeed}px, 0)`;
      contentWrapper.style.opacity = opacity;
    }
  }
})();